import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ISortDepartmentParam {
    department_list: string;
}
export interface ISortDepartmentOutput {
    status: number;
    desc: string;
}
export const sortDepartment = (data: ISortDepartmentParam): Promise<ISortDepartmentOutput> => {
    return fetchData(Api.SORT_DEPARTMENT, data).then((res: IResponse<ISortDepartmentOutput>) => {
        return res.data;
    });
};
